import { useMutation, useQueryClient } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';
import showAlert from '../../../utils/alert';

const updateVesselGroupListQuery = (data) => {
    const { vesselGroupId } = data;
    delete data.vesselGroupId;
  return axios.put(`${apiurl?.updatePpeVesselGroup}/${vesselGroupId}`, data);
};

const updateVesselGroupList = () => {
  const queryClient = useQueryClient();
  return useMutation(updateVesselGroupListQuery, {
    onSuccess: () => {
      showAlert('Vessel Group Updated Successfully!', 'success');
      queryClient.invalidateQueries('getPpeVesselGroup');
    },
    onError: (error) => {
      showAlert(error?.response?.data, 'error');
    }
  });
};

export default updateVesselGroupList;
